module.exports = __webpack_public_path__ + "img/no-missedcall.5369bbeb.svg";